export const CONFIRM_OR_REJECT_FACILITY_DAILY_REPORT_HQ = `
  mutation($facilityDailyReportId: Int!, $status: FacilityDailyReportHQ!) {
    confirmOrRejectFacilityDailyReportHQ(
      data: { facilityDailyReportId: $facilityDailyReportId, status: $status }
    ) {
      id
    }
  }
`
